<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Payouts</h2>

    <div class="export">
      <div class="flex justify-end">
        <div class="ml-auto">
          <button
            @click="exportPayouts"
            :class="{ 'button-loading': exportingPayout }"
            :disabled="exportingPayout || !payouts.length"
            class="button-gemnote button-gemnote--small"
          >
            <span> Export </span>
          </button>
        </div>
      </div>
    </div>
    <div class="flex md:flex-row flex-col gap-5 md:items-end text-left mt-5">
      <Skeleton v-if="loadingShopPayouts" width="50%" height="3.5rem" />
      <template v-else>
        <span class="text-lg font-bold mb-1 hidden">Balance</span>
        <span class="balance font-semibold hidden">{{
          formatCurrency(0)
        }}</span>
      </template>
    </div>

    <div class="flex mt-9  md:flex-row flex-col">
      <Skeleton v-if="loadingShopPayouts" width="100%" height="10rem" />

      <div class="card-holder md:w-1/2 w-full p-5 border-right-mobile" v-else>
        <div class="flex justify-between">
          <div>
            <div class="flex gap-2 items-center">
              <span class="font-bold">Future transfers</span>
              <!-- <div class="tool-tip">
                <Tooltip
                  popOverContent="
                    Includes completed orders for the upcoming payout."
                  popOverPosition="right"
                />
              </div> -->
            </div>
          </div>
          <div class="text-right">
            <span
              class="font-bold text-xs py-2 px-3 rounded-md text-xs pill pending"
              >Pending</span
            >
          </div>
        </div>
        <!-- <div class="mt-6 text-left ">
                   <span>May 20, 2022</span>
        </div> -->
        <div class="mt-3 text-left flex items-center gap-1">
          <span class="text-2xl font-semibold value">{{
            formatCurrency(shopPayouts.metrics.nextPayoutAmount)
          }}</span>
          <span class="text-xl font-light">USD</span>
        </div>
      </div>

      <Skeleton v-if="loadingShopPayouts" width="100%" height="10rem" />

      <div v-else class="card-holder  p-5 md:w-1/2 w-full border-right">
        <div class="flex justify-between">
          <div>
            <div class="flex gap-2 items-center">
              <span class="font-bold">Lifetime total volume</span>
              <!-- <div class="tool-tip">
                <Tooltip
                  popOverContent="
                    Includes all completed orders, including future payouts. Does not include processing or pending orders."
                  popOverPosition="right"
                />
              </div> -->
            </div>
          </div>
          <div class="text-right">
            <span
              class="font-bold text-xs py-2 px-3 rounded pill paid flex gap-2"
            >
              Paid
            </span>
          </div>
        </div>
        <!-- <div class="mt-6 text-left">
                   <span>May 20, 2022</span>
        </div> -->
        <div class="mt-1 text-left">
          <span class="text-2xl font-semibold value">
            {{ formatCurrency(shopPayouts.metrics.previousPayoutAmount) }}
            <span class="text-xl font-light">USD</span>
          </span>
        </div>
      </div>
    </div>

    <div class="mt-8">
      <div v-if="loadingShopPayouts">
        <Skeleton width="100%" height="3rem" v-for="i in 5" :key="i" />
      </div>

      <vue-good-table
        v-else
        styleClass="vgt-table striped payout-table"
        :columns="columns"
        :rows="payouts"
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false
        }"
        slot-scope="columns"
        :totalRows="payoutsPagination.totalCount"
        @on-page-change="handlePageChange"
      >
        <template slot="table-row" slot-scope="payouts">
          <template v-if="payouts.column.field === 'details'">
            <router-link
              :to="'/e-commerce/orders/' + payouts.row.order_uuid"
              class="font-bold underline cursor-pointer"
              >View Details</router-link
            >
          </template>

          <span v-else-if="payouts.column.field === 'status'">
            {{ payouts.row.status | capitalize }}
          </span>
        </template>

        <div slot="emptystate">
          No payouts available
        </div>
        <template slot="pagination-bottom">
          <Pagination
            :total-items="payoutsPagination.totalCount"
            :page="serverParams.page"
            :items-per-page="serverParams.perPage"
            @page-change="handlePageChange"
            @perPageChange="handlePerPageChange"
          />
        </template>
      </vue-good-table>
    </div>
    <!-- Modal Here -->
    <ExportModal
      :showFooter="true"
      v-show="isExportModalActive"
      @hideModal="closeModal"
      :showCancelButton="false"
      @confirmAction="closeModal"
    >
      <template slot="header">
        <span>Exporting Payouts</span>
      </template>

      <template slot="body">
        <span
          >We are exporting your payouts, we will send a link to
          <strong> {{ user.email }} </strong> when it’s done. Keep an eye on
          your inbox!
        </span>
      </template>
    </ExportModal>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { mapState } from 'vuex'
import Skeleton from '../Universal/Skeleton'
import Util from '../../mixins/Util'
import Pagination from '@/components/Universal/Pagination'
import ExportModal from '@/components/Universal/ExportModal'
export default {
  name: 'ECommercePayout',
  mixins: [Util],
  components: {
    VueGoodTable,
    Skeleton,
    Pagination,
    ExportModal
  },
  computed: {
    ...mapState({
      shopPayouts: state => state.ecommerce.shopPayouts,
      loadingShopPayouts: state => state.ecommerce.loadingShopPayouts,
      exportingPayout: state => state.ecommerce.exportingPayout,
      isExportModalActive: state => state.modal.isExportModalActive,
      user: state => state.profile.user
    }),
    payouts() {
      return this.shopPayouts.payouts.map(payout => {
        return {
          date: payout.attributes.createdAt,
          status: payout.attributes.status,
          fulfilment_fee: payout.attributes.fulfillmentFee,
          net_payout: payout.attributes.netPayoutAmount,
          total: payout.attributes.totalAmount,
          tax: payout.attributes.tax,
          shipping_fee: payout.attributes.shippingFee,
          order_uuid: payout.attributes.eCommerceCartUuid
        }
      })
    },
    payoutsPagination() {
      return this.shopPayouts.pagination
    }
  },
  data() {
    return {
      serverParams: {
        page: 0,
        perPage: 10
      },
      columns: [
        {
          label: 'Payment Date',
          field: 'date',
          formatFn: this.formatDate
        },
        {
          label: 'Fulfilment Fees',
          field: 'fulfilment_fee',
          formatFn: this.formatCurrency
        },
        {
          label: 'Shipping Fees',
          field: 'shipping_fee',
          formatFn: this.formatCurrency
        },
        {
          label: 'Taxes',
          field: 'tax',
          formatFn: this.formatCurrency
        },
        {
          label: 'Total',
          field: 'total',
          formatFn: this.formatCurrency
        },
        {
          label: 'Status',
          field: 'status'
        },
        {
          label: 'Amount',
          field: 'net_payout',
          formatFn: this.formatCurrency,
          type: 'number',
          tdClass: 'vgt-left-align'
        },
        {
          label: 'Details',
          field: 'details',
          tdClass: 'shop-view-details-cols',
          sortable: false
        }
      ]
    }
  },
  created() {
    this.getPayouts()
  },
  methods: {
    getPagePayouts(params) {
      this.getPayouts(params.currentPage)
    },
    getPayouts(page = 1) {
      this.$store.dispatch('ecommerce/getShopPayouts', {
        page,
        perPage: this.serverParams.perPage
      })
    },
    handlePageChange(page) {
      this.serverParams.page = page
      this.getPayouts(page + 1)
    },

    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfPayouts()
    },

    getNextChuckOfPayouts() {
      this.$store.dispatch('ecommerce/getShopPayouts', {
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage
      })
    },

    exportPayouts() {
      this.$store.dispatch('modal/handleExports', 'e_commerce_payouts')
    },

    closeModal() {
      this.$store.dispatch('modal/setExportModal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-tip {
  margin-bottom: 10px;
}
.hidden {
  display: none !important;
}
.button-gemnote--small {
  height: 2.4rem;
  padding: 0 1.5rem !important;
  width: auto;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
.balance {
  font-size: 1.75rem;
}

.card-holder {
  border: 1px solid #232220;
  height: max-content;
  border-right: none;

  &.border-right {
    border-right: 1px solid #232220;
  }

  &.border-right-mobile {
    border-right: none;
  }

  @media (max-width: 768px) {
    &.border-right-mobile {
      border-right: 1px solid #232220;
      border-bottom: none;
    }
  }
}

.pill {
  color: #636363;
  border-radius: 6px;

  &.pending {
    background: #dfdad2;
  }

  &.paid {
    background: #68c67e26;
    color: #68c67e;
  }
}

.value {
  color: #24292c;
  font-size: 1.375rem;
}
</style>
